import axios from "axios";
import store from "@/store";
import router from "@/router";

const CSRF_COOKIE_NAME = "csrftoken";
const CSRF_HEADER_NAME = "X-CSRFToken";
const API_HOST = process.env.VUE_APP_GATEWAY_API_HOST || `https://outbound-gateway-mmrasrazea-nw.a.run.app/`;

const session = axios.create({
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
  baseURL: `${API_HOST}/`,
});

export const auth = axios.create({
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
  baseURL: `${API_HOST}/`,
});

session.interceptors.request.use((request) => {
  request.headers.Authorization = `Token ${localStorage.getItem("token")}`;
  request.headers['Content-Type'] = 'application/json';
  return request;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

session.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Token " + token;
            return axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refresh = localStorage.getItem("refresh");

      return new Promise((resolve, reject) => {
        auth
          .post("/tokens/refresh/", { refresh })
          .then(({ data }) => {
            if (data && data.status === 401) {
              store
                .dispatch("auth/logoutUser")
                .then(() => {
                  router.push({ name: "login" });
                })
                .catch(() => {
                  router.push({ name: "login" });
                });
            }
            const token = data.access;
            localStorage.setItem("token", token);
            originalRequest.headers["Authorization"] = `Token ${token}`;
            processQueue(null, token);
            resolve(session(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
            store
              .dispatch("auth/logoutUser")
              .then(() => {
                router.push({ name: "login" });
              })
              .catch(() => {
                router.push({ name: "login" });
              });
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  },
);

export default session;
